export default __webpack_public_path__ + "static/media/Photosnap - Preview 2.510bba0c.png";